/**
 * 用户接口
 * 科大平台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The SmsSignupForm model module.
   * @module token/model/SmsSignupForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>SmsSignupForm</code>.
   * @alias module:token/model/SmsSignupForm
   * @class
   * @param phone {String} 手机号
   * @param nick {String} 昵称
   * @param smsCode {String} 手机号验证码
   * @param password {String} 密码
   * @param confirmPassword {String} 确认密码
   */
  var exports = function(phone, nick, smsCode, password, confirmPassword) {
    var _this = this;

    _this['phone'] = phone;
    _this['nick'] = nick;

    _this['smsCode'] = smsCode;
    _this['password'] = password;
    _this['confirmPassword'] = confirmPassword;
  };

  /**
   * Constructs a <code>SmsSignupForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/SmsSignupForm} obj Optional instance to populate.
   * @return {module:token/model/SmsSignupForm} The populated <code>SmsSignupForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'phone')) {
        obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'nick')) {
        obj['nick'] = ApiClient.convertToType(data['nick'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'smsCode')) {
        obj['smsCode'] = ApiClient.convertToType(data['smsCode'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'password')) {
        obj['password'] = ApiClient.convertToType(data['password'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'confirmPassword')) {
        obj['confirmPassword'] = ApiClient.convertToType(data['confirmPassword'], 'String');
      }
    }
    return obj;
  }

  /**
   * 手机号
   * @member {String} phone
   */
  exports.prototype['phone'] = undefined;
  /**
   * 昵称
   * @member {String} nick
   */
  exports.prototype['nick'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 手机号验证码
   * @member {String} smsCode
   */
  exports.prototype['smsCode'] = undefined;
  /**
   * 密码
   * @member {String} password
   */
  exports.prototype['password'] = undefined;
  /**
   * 确认密码
   * @member {String} confirmPassword
   */
  exports.prototype['confirmPassword'] = undefined;



  export default exports;
;


